export const CALENDLY_URL = "https://calendly.com/kumen-stoutroad/30min";

export function openCalendly() {
    if (typeof window !== "undefined" && window.Calendly) {
        window.Calendly.initPopupWidget({ url: CALENDLY_URL });
        return false;
    }
    // Fallback: open in a new tab if script hasn't loaded yet
    if (typeof window !== "undefined") {
        window.open(CALENDLY_URL, "_blank", "noopener,noreferrer");
    }
    return false;
}
